<template>
    <div id="print" class="big_cat_screen" v-if="bigCat5 != null" :style="{'background-color': '#275ba9'}">
        <div class="back_nav" @click="backNav()"><img src="../../assets/back_nav.png"/></div>

        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="@/assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="@/Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>概念词汇</span>
                            <img src="@/assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <audio class="audio" :src="greatAudio" id="great_audio" @ended="playMp3Ended('great_audio')" @error="playMp3Ended('great_audio')"/>

        <!-- 播放视图 -->
        <div class="lesson_audio">
            <div class="info">
                <div class="title">读前拓展</div>
                <div class="mp3_progress">
                    <div class="now_progress" v-bind:style="{width: progress+ '%'}"></div>
                </div>
                <div class="time">
                    <div class="time_start">{{realFormatSecond(currentTime)}}</div>
                    <div class="time_end">{{bigCat5.highlightInterpretationAudioDurationDisplayString}}</div>
                    <div class="clear"></div>
                </div>
            </div>
            <div class="play" @click="changeStart">
                <audio v-bind:src="$qiNiuDomainBase + bigCat5.highlightInterpretationAudio" id="musicMp3" controls="" @ended="playEnded" />
                <img v-if="!isPlaying" src="@/assets/player_play.png" height="60" width="60"/>
                <img v-else src="@/assets/player_pause.png" height="60" width="60"/>
            </div>
        </div>

    </div>
</template>

<script>

    import $ from "jquery";
    import Utils from '@/pages/Program/util2.js';

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top', (height-width)/2 );
            vPrint.css('left', 0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                bigCat5: null,
                currentTime:0,
                isPlaying: false,
                progress: 0,
                mTimer: null,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                showTransition:false,
            }
        },
        methods: {
            backNav() {
                this.goBack(this.$router);
            },
            gameQuitClick() {
                this.showTransition = false;
                this.$router.go(-1);
            },
            nextPageClick: function () {
                this.showTransition = false;
                this.$router.replace({name: 'BFFollow', query: {lessonId: this.lessonId}});
            },
            changeStart: function () {
                let that = this;
                that.isPlaying = !that.isPlaying;
                const musicMp3 = document.getElementById('musicMp3');
                if (that.isPlaying) {
                    if (that.mTimer == null) {
                        that.changeProgress();
                    }

                    setTimeout(() => {
                        that.isPlaying = true;
                        let playPromise = musicMp3.play();

                        if (playPromise !== undefined) {
                            playPromise.then(() => {
                            }).catch((e) => {
                                let vError = JSON.stringify(e);

                                if (!that.isEmpty(vError) && vError !== "{}") {
                                    that.isPlaying = false;
                                    window.console.log("播放失败:playAudio:" + vError);
                                }
                            });
                        } else {
                            that.isPlaying = false;
                            window.console.log("播放失败:playAudio");
                        }
                    }, 100);
                } else {
                    musicMp3.pause();
                }
            },
            playMp3Ended(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            playEnded() {
                this.isPlaying = false;
                this.showTransition = true;
                const greatAudio = document.getElementById('great_audio');
                greatAudio.play();

                Utils.$emit('setBigCat5Finished', this.lessonId, 1);
            },
            changeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3');

                that.mTimer = setInterval(() => {
                    const numbers = musicMp3.currentTime / musicMp3.duration;
                    let perNumber = (numbers * 100).toFixed(2);

                    if (perNumber >= 100) {
                        that.isPlaying = false;
                        that.progress = 0;
                        that.currentTime = 0;
                        clearInterval(that.mTimer);
                        that.mTimer = null;
                    } else {
                        that.progress = perNumber;
                        that.currentTime = musicMp3.currentTime;
                    }
                }, 50)
            },
            callChangeProgress:function () {
                let that = this;
                let vAudio = document.getElementById('musicMp3');

                if (vAudio != null) {
                    vAudio.pause();
                    that.changeProgress();
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:0";
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(0);
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = that.getCount(that.$route.query.lessonId);

            let url = "bigCat/getHighlightInterpretationAudio/" + vLessonId;
            that.$axios.get(url).then((response) => {
                that.bigCat5 = response.data;
                that.lessonId = vLessonId;

                var t;
                clearTimeout(t);
                t = setTimeout(function () {
                    transformView();

                    setTimeout(function () {
                        that.changeStart();

                        setTimeout(function () {
                            that.hideStatusAndStopAudio();
                        }, 200);
                    }, 200);
                }, 100);
            }).catch(function (error) {
                alert(error)
            });
        },
        mounted: function () {
            this.callChangeProgress();
        },
        destoryed() {
            let that = this;

            if (that.mTimer != null) {
                clearInterval(that.mTimer);
                that.mTimer = null
            }
        },
    }
</script>

<style scoped>

    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .lesson_audio {
        position: absolute;
        width: calc(100vmax - 160px);
        height: 180px;
        top: calc(50vmin - 90px);
        bottom: 74px;
        background-color: #0000006a;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        display: flex;
    }

    .lesson_audio .info {
        width: calc(100vmax - 160px - 150px);
        margin-left: 30px;
    }

    .lesson_audio .play {
        position: absolute;
        top: 50%;
        right: 30px;
        -webkit-transform: translateY(-50%);
    }

    .lesson_audio .info .title {
        margin-top: 30px;
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
    }

    .lesson_audio .info .mp3_progress {
        width: 100%;
        height: 10px;
        background-color: #f4f4f4;
        margin-top: 30px;
        margin-bottom: 12px;
    }

    .lesson_audio .info .now_progress {
        position: relative;
    @extend % transition;
        height: 10px;
        background-color: #64c846;
    }

    .lesson_audio .time {
        font-size: 14px;
        color: #f4f4f4;
    }

    .lesson_audio .time .time_start {
        float: left;
    }

    .lesson_audio .time .time_end {
        float: right;
    }

    audio {
        display: none;
    }

    .transition {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .content2 {
        text-align: center;
    }

    .transition .content3 {
        text-align: center;
    }
    .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .transition .content .text span {
        display: block;
        text-align: center;
    }
    .transition .content .text .success_tip {
        font-size: 24px;
    }
    .transition .content .star {
        height: 35px;
    }
    .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }

</style>
